import {
  SET_USER_PROFILE,
  IS_REQUESTING,
  UPDATE_USER_NAME_AND_GENDER,
  SET_REFERRALS_DATA,
  UPDATE_BABY_DOB,
  CLEAR_USER_PROFILE,
} from "./constants";

const initialState = {
  userProfile: {},
  isRequesting: false,
  referrals_data: {},
};

/**
 * Define the reducer with actions
 *
 * @param {Object} state
 * @param {Object} action
 */
function UserProfileReducer(state = initialState, action) {
  switch (action.type) {
    case SET_USER_PROFILE:
      return {
        ...state,
        userProfile: action.data,
        isRequesting: false,
      };

    case UPDATE_USER_NAME_AND_GENDER:
      return {
        ...state,
        userProfile: {
          ...state.userProfile,
          user_name: action.data.user_name,
          gender: action.data.gender,
        },
      };

    case UPDATE_BABY_DOB:
      return {
        ...state,
        userProfile: {
          ...state.userProfile,
          baby_details: {
            ...state.userProfile.baby_details,
            date_of_birth: action.data.date_of_birth,
          },
        },
      };

    case IS_REQUESTING:
      return {
        ...state,
        isRequesting: action.data,
      };

    case SET_REFERRALS_DATA:
      return {
        ...state,
        referrals_data: action.data,
      };

    case CLEAR_USER_PROFILE:
      return {
        ...state,
        userProfile: {},
        referrals_data: {},
        isRequesting: false,
      };

    default:
      return state;
  }
}

export default UserProfileReducer;
